import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getCommentList, getRatingList, partnerApi, vendorDashboard } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import {
  Collapse, CardBody, Card, CardHeader, Modal, ModalBody, Row, Col, ModalFooter, ModalHeader
} from 'reactstrap';

import Tabs from "../Tabs";

import TabsPane from "../Tabs/TabsPane";

import DataTable from 'react-data-table-component';

const childTabs = [
  {
    name: "Parent Reviews",
    id: "Reviews",
    defaultChecked: true,
  },
  {
    name: "Parent Ratings",
    id: "Ratings",
  },
  {
    name: "Partner Connect",
    id: "Enquiries",
  },
];

const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold'
    },
  },
};

class partnerReview extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, checking: false, modalReply: false, modalReplyEnq: false,
      current_comment: '', current_rid: 0, current_eid: ''
    }
    this.getpageData();
    this.toggle = this.toggle.bind(this);
  }


  showMTab = (element) => {

    $('.submenu-list a').each(function () {
      $(this).removeClass('active');

    });

    $("." + element).addClass("active");
    $(".mainblock").removeClass('active').addClass('hidden');
    $("#" + element).removeClass('hidden').addClass('active');

    //document.getElementById(element).style.display = 'block';
  }

  getpageData = async () => {
    const { user_type, login_id, set_id } = this.state.auth_data;
    let insdata = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      sid: set_id,
      url: 'getAbout'
    });
    await partnerApi(insdata).then((response) => {
      if (response.status === 1) {
        this.setState({
          checking: false,
          category_data: response.result.master_data,
        })
        const data = response.result.master_data;
        if (data.length > 0) {
          data.map(async (item, index) => {
            console.log('item.mid', item.mid);
            let userinfo = JSON.stringify({
              vendor_id: login_id,
              category: item.cid,
              main_id: item.mid,
            });

            getCommentList(userinfo).then((response) => {
              if (response.status == 1) {
                item.comments = response.results;
              }
            });
            getRatingList(userinfo).then((response) => {
              if (response.status == 1) {
                let school = response.data[0].schoolrating[0];
                let preschool = response.data[0].preschoolrating[0];
                let playarea = response.data[0].playarearating[0];
                let hobbies = response.data[0].hobbiesarating[0];
                let tution = response.data[0].tutionrating[0];
                let camp = response.data[0].camprating[0];
                let advice = response.data[0].advicerating[0];
                let event = response.data[0].eventrating[0];

                item.school_child_safety = school ? school.school_child_safety : '0.0';
                item.school_covid19 = school ? school.school_covid19 : '0.0';
                item.school_facilities = school ? school.school_facilities : '0.0';
                item.school_food = school ? school.school_food : '0.0';
                item.school_infrastructure = school ? school.school_infrastructure : '0.0';
                item.school_overall_expirence = school ? school.school_overall_expirence : '0.0';
                item.school_qty_info_website = school ? school.school_qty_info_website : '0.0';
                item.school_qty_interaction = school ? school.school_qty_interaction : '0.0';
                item.school_qty_teachers = school ? school.school_qty_teachers : '0.0';
                item.school_qty_teaching = school ? school.school_qty_teaching : '0.0';
                item.school_teacher_student_ratio = school ? school.school_teacher_student_ratio : '0.0';
                item.school_transport_arrange = school ? school.school_transport_arrange : '0.0';
                item.school_rating = school ? school.school_rating : false,

                  item.preschool_child_safety = preschool ? preschool.preschool_child_safety : '0.0';
                item.preschool_covid19 = preschool ? preschool.preschool_covid19 : '0.0';
                item.preschool_facilities = preschool ? preschool.preschool_facilities : '0.0';
                item.preschool_food = preschool ? preschool.preschool_food : '0.0';
                item.preschool_infrastructure = preschool ? preschool.preschool_infrastructure : '0.0';
                item.preschool_overall_expirence = preschool ? preschool.preschool_overall_expirence : '0.0';
                item.preschool_qty_info_website = preschool ? preschool.preschool_qty_info_website : '0.0';
                item.preschool_qty_interaction = preschool ? preschool.preschool_qty_interaction : '0.0';
                item.preschool_qty_teachers = preschool ? preschool.preschool_qty_teachers : '0.0';
                item.preschool_qty_teaching = preschool ? preschool.preschool_qty_teaching : '0.0';
                item.preschool_teacher_student_ratio = preschool ? preschool.preschool_teacher_student_ratio : '0.0';
                item.preschool_transport_arrange = preschool ? preschool.preschool_transport_arrange : '0.0';
                item.preschool_rating = preschool ? preschool.preschool_rating : false,

                  item.playarea_child_safety = playarea ? playarea.playarea_child_safety : '0.0';
                item.playarea_cleanliness = playarea ? playarea.playarea_cleanliness : '0.0';
                item.playarea_covid19 = playarea ? playarea.playarea_covid19 : '0.0';
                item.playarea_crowd_size = playarea ? playarea.playarea_crowd_size : '0.0';
                item.playarea_facilities_location = playarea ? playarea.playarea_facilities_location : '0.0';
                item.playarea_facilities_parent = playarea ? playarea.playarea_facilities_parent : '0.0';
                item.playarea_food = playarea ? playarea.playarea_food : '0.0';
                item.playarea_overall_expirence = playarea ? playarea.playarea_overall_expirence : '0.0';
                item.playarea_qty_info_website = playarea ? playarea.playarea_qty_info_website : '0.0';
                item.playarea_qty_staff = playarea ? playarea.playarea_qty_staff : '0.0';
                item.playarea_rating = playarea ? playarea.playarea_rating : false,

                  item.hobbies_covid19 = hobbies ? hobbies.hobbies_covid19 : '0.0';
                item.hobbies_qty_teachers = hobbies ? hobbies.hobbies_qty_teachers : '0.0';
                item.hobbies_qty_teaching = hobbies ? hobbies.hobbies_qty_teaching : '0.0';
                item.hobbies_qty_info_website = hobbies ? hobbies.hobbies_qty_info_website : '0.0';
                item.hobbies_child_safety = hobbies ? hobbies.hobbies_child_safety : '0.0';
                item.hobbies_facilities_parent = hobbies ? hobbies.hobbies_facilities_parent : '0.0';
                item.hobbies_campus_facilities = hobbies ? hobbies.hobbies_campus_facilities : '0.0';
                item.hobbies_qty_intraction = hobbies ? hobbies.hobbies_qty_intraction : '0.0';
                item.hobbies_batch_size = hobbies ? hobbies.hobbies_batch_size : '0.0';
                item.hobbies_overall_expirence = hobbies ? hobbies.hobbies_overall_expirence : '0.0';
                item.hobbies_rating = hobbies ? hobbies.hobbies_rating : false,


                  item.tution_covid19 = tution ? tution.tution_covid19 : '0.0';
                item.tution_qty_teachers = tution ? tution.tution_qty_teachers : '0.0';
                item.tution_qty_teaching = tution ? tution.tution_qty_teaching : '0.0';
                item.tution_child_safety = tution ? tution.tution_child_safety : '0.0';
                item.tution_facilities = tution ? tution.tution_facilities : '0.0';
                item.tution_ontime_punctuality = tution ? tution.tution_ontime_punctuality : '0.0';
                item.tution_overall_expirence = tution ? tution.tution_overall_expirence : '0.0';
                item.tution_rating = tution ? tution.tution_rating : false,

                  item.advice_covid19 = advice ? advice.advice_covid19 : '0.0';
                item.advice_qty_teachers = advice ? advice.advice_qty_teachers : '0.0';
                item.advice_qty_teaching = advice ? advice.advice_qty_teaching : '0.0';
                item.advice_child_safety = advice ? advice.advice_child_safety : '0.0';
                item.advice_facilities = advice ? advice.advice_facilities : '0.0';
                item.advice_ontime_punctuality = advice ? advice.advice_ontime_punctuality : '0.0';
                item.advice_overall_expirence = advice ? advice.advice_overall_expirence : '0.0';
                item.advice_rating = advice ? advice.advice_rating : false,

                  item.camp_covid19 = camp ? camp.camp_covid19 : '0.0';
                item.camp_qty_teachers = camp ? camp.camp_qty_teachers : '0.0';
                item.camp_qty_teaching = camp ? camp.camp_qty_teaching : '0.0';
                item.camp_qty_food = camp ? camp.camp_qty_food : '0.0';
                item.camp_campus_facilities = camp ? camp.camp_campus_facilities : '0.0';
                item.camp_child_safety = camp ? camp.camp_child_safety : '0.0';
                item.camp_facilities_parents = camp ? camp.camp_facilities_parents : '0.0';
                item.camp_qty_info_website = camp ? camp.camp_qty_info_website : '0.0';
                item.camp_crowd_size = camp ? camp.camp_crowd_size : '0.0';
                item.camp_infrastructure = camp ? camp.camp_infrastructure : '0.0';
                item.camp_transport_arrange = camp ? camp.camp_transport_arrange : '0.0';
                item.camp_overall_expirence = camp ? camp.camp_overall_expirence : '0.0';
                item.camp_rating = camp ? camp.camp_rating : false,

                  item.event_covid19 = event ? event.event_covid19 : '0.0';
                item.event_qty_food = event ? event.event_qty_food : '0.0';
                item.event_qty_info_website = event ? event.event_qty_info_website : '0.0';
                item.event_ontime_punctuality = event ? event.event_ontime_punctuality : '0.0';
                item.event_overall_expirence = event ? event.event_overall_expirence : '0.0';
                item.event_rating = event ? event.event_rating : false;
              }
            });
          })
        }
        let THIS = this;
        this.setState({
          checking: false,
        })
        setTimeout(function () {
          THIS.setState({
            checking: true,
          })
        }, 5000)
      }
    });
  }
  componentDidMount() {
    // this.CommentList();
    // this.EnquiriesList();
    // this.RatingList()

  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  toggle = (e, event) => {
    e.preventDefault();
    this.setState({
      collapse: this.state.collapse === Number(event) ? -1 : Number(event),
      loginPop: false
    });
  }

  render() {
    const { category_data, collapse } = this.state;
    const columns_pc = [
      {
        name: 'Name',
        selector: row => row.name,
        sortable: true,
      },
      {
        name: 'Email',
        selector: row => row.name,
        wrap: true,
        sortable: true,
        format: row => row.email.length > 200 ? `${row.email.slice(0, 200)}...` : row.email,
      },
      {
        name: 'Date',
        selector: row => row.name,
        selector: 'month',
      },
      {
        name: 'Message',
        selector: row => row.comments,
        wrap: true,
        sortable: true,
        format: row => row.comments.length > 200 ? `${row.comments.slice(0, 200)}...` : row.comments,
      },
      {
        name: 'Status',
        selector: row => row.status,
        cell: row => row.status == 0 ? (<span class="label label-primary pointer" onClick={() => this.sendReplyEnq(row)}>Reply</span>) : (<span class="label label-success">Replied</span>)
      },
    ];
    const columns_comments = [
      {
        name: 'Date Posted',
        selector: row => row.date,
        sortable: true,
      },
      {
        name: 'Name',
        selector: row => row.name,
      },
      {
        name: 'Email id',
        selector: row => row.email,
        wrap: true,
        sortable: true,
        format: row => row.email && row.email.length > 200 ? `${row.email.slice(0, 200)}...` : row.email,
      },
      {
        name: 'Comments',
        selector: row => row.comments,
        wrap: true,
        sortable: true,
        format: row => row.comments && row.comments.length > 200 ? `${row.comments.slice(0, 200)}...` : row.comments,
      },
      {
        name: 'Status',
        selector: row => row.status,
        cell: row => row.status == 0 ? (<span class="label label-primary pointer" onClick={() => this.sendReply(row)}>Reply</span>) : (<span class="label label-success">Replied</span>)
      },
      {
        name: 'Replied',
        selector: row => row.reply_comments,
        wrap: true,
        sortable: true,
        format: row => row.reply_comments && row.reply_comments.length > 200 ? `${row.reply_comments.slice(0, 200)}...` : row.reply_comments,
      },
    ];
        return (
            <React.Fragment>
                <AdminLayout>
                    
              <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Parent Feedback and Interactions</h4>
                   
                   <div class="desktoponly">

                    <Tabs tabsetName="Comments" childTabs={childTabs}>
                    <TabsPane id="Reviews">
                      <div className="row">
                        <Modal isOpen={this.state.modalReply}>
                          <form onSubmit={this.replyMail}>
                            <ModalHeader>
                              <h3>Send Response</h3>
                            </ModalHeader>
                            <ModalBody className='p-0'>
                              <div className='row'>
                                <div className='col-md-12 form-group'>
                                  <label>Message</label>
                                  <textarea className='form-control' value={this.state.current_comment} />
                                </div>
                                <div className='col-md-12 form-group'>
                                  <label>Reply</label>
                                  <textarea rows={5} className='form-control' required
                                    onChange={this.handleChange} name='new_reply' value={this.state.new_reply} />
                                </div>
                              </div>
                            </ModalBody>
                            <ModalFooter>
                              <div className='row'>
                                <div className='col-md-12'>
                                  <button className='btn btn-sm btn-default' onClick={this.cancelPop}>Close</button>
                                  <button type='submit' className='btn btn-sm btn-success'>Reply</button>
                                </div>
                              </div>

                            </ModalFooter>
                          </form>
                        </Modal>
                        <div className="col-md-12 mar-btm-60">
                          {category_data.map((item, index) => {
                            return (
                              <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={index}>
                                <CardHeader onClick={(e) => this.toggle(e, index)} data-event={index} className='custom-card-heading'>
                                  <b>{item.category_name}</b>
                                  <small>{item.sub_category_name ? ' - ' + item.sub_category_name : ''}</small>
                                  {collapse !== index ? (
                                    <span className='pull-right'>
                                      <i class="fa fa-plus" aria-hidden="true"></i>
                                    </span>
                                  ) : (
                                    <span className='pull-right'>
                                      <i class="fa fa-minus" aria-hidden="true"></i>
                                    </span>
                                  )}
                                </CardHeader>
                                <Collapse isOpen={collapse === index}>
                                  <CardBody className='panel-body'>
                                    {item.is_active == 0 ?
                                      (
                                        <div className='row mar-btm'>
                                          <div class="form-group col-md-12">
                                            <h3 className='text-center'>Upgrade/Renewal to update the Data</h3>
                                          </div>
                                        </div>
                                      ) :
                                      (
                                        <div>
                                          {item.comments && item.comments.length > 0 && (
                                            <button className='btn btn-sm btn-success pull-right' onClick={(e) => this.exportComment(e, item)}>Export</button>
                                          )}
                                          <DataTable
                                            title=""
                                            columns={columns_comments}
                                            data={item.comments}
                                            pagination
                                            customStyles={customStyles}
                                            paginationComponentOptions={{ noRowsPerPage: true }}
                                          />
                                        </div>
                                      )
                                    }
                                  </CardBody>
                                </Collapse>
                              </Card>
                            )
                          })}
                        </div>
                      </div>
                    </TabsPane>
                    <TabsPane id="Ratings">
                      {category_data.map((item, index) => {
                        return (
                          <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={index}>
                            <CardHeader onClick={(e) => this.toggle(e, index)} data-event={index} className='custom-card-heading'>
                              <b>{item.category_name}</b>
                              <small>{item.sub_category_name ? ' - ' + item.sub_category_name : ''}</small>
                              {collapse !== index ? (
                                <span className='pull-right'>
                                  <i class="fa fa-plus" aria-hidden="true"></i>
                                </span>
                              ) : (
                                <span className='pull-right'>
                                  <i class="fa fa-minus" aria-hidden="true"></i>
                                </span>
                              )}
                            </CardHeader>
                            <Collapse isOpen={collapse === index}>
                              <CardBody className='panel-body'>
                                {item.is_active == 0 ?
                                  (
                                    <div className='row mar-btm'>
                                      <div class="form-group col-md-12">
                                        <h3 className='text-center'>Upgrade/Renewal to update the Data</h3>
                                      </div>
                                    </div>
                                  ) :
                                  this.state.checking && (

                                    <div className="table-responsive custom-table-wrap content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                                      <table className='table dataTable'>
                                        <thead>
                                          <tr>
                                            {(item.preschool_rating === true || item.school_rating === true) ?
                                              <React.Fragment>
                                                <th>Covid19 Responses/ Precautions</th>
                                                <th>Child Safety @ premises</th>
                                                <th>Quality of Teachers</th>
                                                <th>Quality of information in website</th>
                                                <th>Quality of Teaching</th>
                                                <th>Campus & Facilities</th>
                                                <th>Quality of Interaction with other staff </th>
                                                <th>Transport arrangements</th>
                                                <th>Food at Campus</th>
                                                <th>Teacher to Students ratio</th>
                                                <th>Infrastructure</th>
                                                <th>Overall Ratings / Experience</th>
                                              </React.Fragment> : ''}
                                            {(item.playarea_rating === true) ?
                                              <React.Fragment>
                                                <th>Covid19 Responses/ Precautions</th>
                                                <th>Quality of food </th>
                                                <th>Quality of Staff</th>
                                                <th>Facilities @ location</th>
                                                <th>Cleanliness</th>
                                                <th>Quality of information @ Website</th>
                                                <th>Child Safety @ premises</th>
                                                <th>Fair Crowd size</th>
                                                <th>Facilities for parents @ Wait</th>
                                                <th>Overall Ratings / Experience</th>
                                              </React.Fragment> : ''}
                                            {(item.hobbies_rating === true) ?
                                              <React.Fragment>
                                                <th>Covid19 Responses/ Precautions</th>
                                                <th>Facilities for Parents @ Wait / Quality of Online Connection</th>
                                                <th>Quality of Teachers / Coaches</th>
                                                <th>Campus & Facilities</th>
                                                <th>Quality of Teaching / Coaching</th>
                                                <th>Quality of interaction with other staff</th>
                                                <th>Quality of information provided @ Website</th>
                                                <th>Student size per batch </th>
                                                <th>Child Safety @ premises</th>
                                                <th>Overall Ratings / Experience</th>
                                              </React.Fragment> : ''}

                                            {(item.tution_rating === true || item.advice_rating === true) ?
                                              <React.Fragment>
                                                <th>Covid19 Responses/ Precautions</th>
                                                <th>Campus & Facilities / Quality of Online Connection</th>
                                                <th>Quality of Teachers / Coaches / Counsellors (Capabilities)</th>
                                                <th>Ontime / Punctuality</th>
                                                <th>Quality of Teaching / Coaching / Counselling (Content)</th>
                                                <th>Overall Ratings / Experience</th>
                                                <th>Child Safety @ location</th>
                                              </React.Fragment> : ''}
                                            {(item.camp_rating === true) ?
                                              <React.Fragment>
                                                <th>Covid19 Responses/ Precautions</th>
                                                <th>Facilities for parents @ Wait</th>
                                                <th>Quality of Teachers / Coaches (Capabilities)</th>
                                                <th>Quality of information @ Website / Posters</th>
                                                <th>Quality of Teaching / Coaching (Content)</th>
                                                <th>Fair Crowd size</th>
                                                <th>Quality of food</th>
                                                <th>Infrastructure </th>
                                                <th>Campus & Facilities / Quality of Online Connection</th>
                                                <th>Transport arrangements</th>
                                                <th>Child Safety @ premisis</th>
                                                <th>Overall Ratings / Experience</th>
                                              </React.Fragment> : ''}
                                          </tr>
                                        </thead>
                                        <tbody>

                                          <tr style={{ 'background': '#ffffff' }}>
                                            {(item.preschool_rating === true) ?
                                              <React.Fragment>
                                                <td>{item.preschool_covid19}</td>
                                                <td>{item.preschool_child_safety}</td>
                                                <td>{item.preschool_qty_teachers}</td>
                                                <td>{item.preschool_qty_info_website}</td>
                                                <td>{item.preschool_qty_teaching}</td>
                                                <td>{item.preschool_facilities}</td>
                                                <td>{item.preschool_qty_interaction}</td>
                                                <td>{item.preschool_transport_arrange}</td>
                                                <td>{item.preschool_food}</td>
                                                <td>{item.preschool_teacher_student_ratio}</td>
                                                <td>{item.preschool_infrastructure}</td>
                                                <td>{item.preschool_overall_expirence}</td>
                                              </React.Fragment> : ''}
                                          </tr>
                                          <tr style={{ 'background': '#ffffff' }}>
                                            {(item.school_rating === true) ?
                                              <React.Fragment>
                                                <td>{item.school_covid19}</td>
                                                <td>{item.school_child_safety}</td>
                                                <td>{item.school_qty_teachers}</td>
                                                <td>{item.school_qty_info_website}</td>
                                                <td>{item.school_qty_teaching}</td>
                                                <td>{item.school_facilities}</td>
                                                <td>{item.school_qty_interaction}</td>
                                                <td>{item.school_transport_arrange}</td>
                                                <td>{item.school_food}</td>
                                                <td>{item.school_teacher_student_ratio}</td>
                                                <td>{item.school_infrastructure}</td>
                                                <td>{item.school_overall_expirence}</td>
                                              </React.Fragment> : ''}

                                          </tr>

                                          <tr style={{ 'background': '#ffffff' }}>
                                            {(item.playarea_rating === true) ?
                                              <React.Fragment>
                                                <td>{item.playarea_covid19}</td>
                                                <td>{item.playarea_child_safety}</td>
                                                <td>{item.playarea_overall_expirence}</td>
                                                <td>{item.playarea_food}</td>
                                                <td>{item.playarea_qty_staff}</td>
                                                <td>{item.playarea_facilities_location}</td>
                                                <td>{item.playarea_cleanliness}</td>
                                                <td>{item.playarea_qty_info_website}</td>
                                                <td>{item.playarea_crowd_size}</td>
                                                <td>{item.playarea_facilities_parent}</td>
                                              </React.Fragment> : ''}

                                          </tr>

                                          <tr style={{ 'background': '#ffffff' }}>
                                            {(item.hobbies_rating === true) ?
                                              <React.Fragment>
                                                <td>{item.hobbies_covid19}</td>
                                                <td>{item.hobbies_facilities_parent}</td>
                                                <td>{item.hobbies_qty_teachers}</td>
                                                <td>{item.hobbies_campus_facilities}</td>
                                                <td>{item.hobbies_qty_teaching}</td>
                                                <td>{item.hobbies_qty_intraction}</td>
                                                <td>{item.hobbies_qty_info_website}</td>
                                                <td>{item.hobbies_batch_size}</td>
                                                <td>{item.hobbies_child_safety}</td>
                                                <td>{item.hobbies_covid19}</td>
                                              </React.Fragment> : ''}

                                          </tr>


                                          <tr style={{ 'background': '#ffffff' }}>
                                            {(item.tution_rating === true) ?
                                              <React.Fragment>
                                                <td>{item.tution_covid19}</td>
                                                <td>{item.tution_facilities}</td>
                                                <td>{item.tution_qty_teachers}</td>
                                                <td>{item.tution_ontime_punctuality}</td>
                                                <td>{item.tution_qty_teaching}</td>
                                                <td>{item.tution_overall_expirence}</td>
                                                <td>{item.tution_child_safety}</td>
                                              </React.Fragment> : ''}

                                          </tr>

                                          <tr style={{ 'background': '#ffffff' }}>
                                            {(this.state.camp_rating === true) ?
                                              <React.Fragment>
                                                <td>{item.camp_covid19}</td>
                                                <td>{item.camp_facilities_parents}</td>
                                                <td>{item.camp_qty_teachers}</td>
                                                <td>{item.camp_qty_info_website}</td>
                                                <td>{item.camp_qty_teaching}</td>
                                                <td>{item.camp_crowd_size}</td>
                                                <td>{item.camp_qty_food}</td>
                                                <td>{item.camp_infrastructure}</td>
                                                <td>{item.camp_campus_facilities}</td>
                                                <td>{item.camp_transport_arrange}</td>
                                                <td>{item.camp_child_safety}</td>
                                                <td>{item.camp_overall_expirence}</td>
                                              </React.Fragment> : ''}
                                          </tr>

                                          <tr style={{ 'background': '#ffffff' }}>
                                            {(item.event_rating === true) ?
                                              <React.Fragment>
                                                <td>{item.event_covid19}</td>
                                                <td>{item.event_covid19}</td>
                                                <td>{item.event_covid19}</td>
                                                <td>{item.event_covid19}</td>
                                                <td>{item.event_covid19}</td>
                                              </React.Fragment> : ''}
                                          </tr>


                                          <tr style={{ 'background': '#ffffff' }}>
                                            {(item.advice_rating === true) ?
                                              <React.Fragment>
                                                <td>{item.advice_covid19}</td>
                                                <td>{item.advice_facilities}</td>
                                                <td>{item.advice_qty_teachers}</td>
                                                <td>{item.advice_ontime_punctuality}</td>
                                                <td>{item.advice_qty_teaching}</td>
                                                <td>{item.advice_overall_expirence}</td>
                                                <td>{item.advice_child_safety}</td>
                                              </React.Fragment> : ''}
                                          </tr>
                                        </tbody>
                                      </table>

                                    </div>
                                  )
                                }
                              </CardBody>
                            </Collapse>
                          </Card>
                        )
                      })}

                    </TabsPane>
                    <TabsPane id="Enquiries">
                      <Modal isOpen={this.state.modalReplyEnq}>
                        <form onSubmit={this.replyMailEnq}>
                          <ModalHeader>
                            <h3>Send Response</h3>
                          </ModalHeader>
                          <ModalBody className='p-0'>
                            <div className='row'>
                              <div className='col-md-12 form-group'>
                                <label>Message</label>
                                <textarea className='form-control' value={this.state.current_comment} />
                              </div>
                              <div className='col-md-12 form-group'>
                                <label>Reply</label>
                                <textarea rows={5} className='form-control' required
                                  onChange={this.handleChange} name='new_reply' value={this.state.new_reply} />
                              </div>
                            </div>
                          </ModalBody>
                          <ModalFooter>
                            <div className='row'>
                              <div className='col-md-12'>
                                <button className='btn btn-sm btn-default' onClick={this.cancelPop}>Close</button>
                                <button type='submit' className='btn btn-sm btn-success'>Reply</button>
                              </div>
                            </div>

                          </ModalFooter>
                        </form>
                      </Modal>
                      {category_data.map((item, index) => {
                        return (
                          <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={index}>
                            <CardHeader onClick={(e) => this.toggle(e, index)} data-event={index} className='custom-card-heading'>
                              <b>{item.category_name}</b>
                              <small>{item.sub_category_name ? ' - ' + item.sub_category_name : ''}</small>
                              {collapse !== index ? (
                                <span className='pull-right'>
                                  <i class="fa fa-plus" aria-hidden="true"></i>
                                </span>
                              ) : (
                                <span className='pull-right'>
                                  <i class="fa fa-minus" aria-hidden="true"></i>
                                </span>
                              )}
                            </CardHeader>
                            <Collapse isOpen={collapse === index}>
                              <CardBody className='panel-body'>
                                {item.is_active == 0 ?
                                  (
                                    <div className='row mar-btm'>
                                      <div class="form-group col-md-12">
                                        <h3 className='text-center'>Upgrade/Renewal to update the Data</h3>
                                      </div>
                                    </div>
                                  ) :
                                  (
                                    <div>
                                      {item.partner_connect && item.partner_connect.length > 0 && (
                                        <button className='btn btn-sm btn-success pull-right' onClick={(e) => this.exportConnect(e, item)}>Export</button>
                                      )}
                                      <DataTable
                                        title=""
                                        columns={columns_pc}
                                        data={item.partner_connect}
                                        pagination
                                        customStyles={customStyles}
                                        paginationComponentOptions={{ noRowsPerPage: true }}
                                      />
                                    </div>
                                  )
                                }
                              </CardBody>
                            </Collapse>
                          </Card>
                        )
                      })}
                    </TabsPane>
                  </Tabs>
                  </div>
                  <div className='box-shadow-custom'>
                    <h5 className='astrick'><b>Notes</b></h5>
                    <ul>
                      <li>
                        Parent feedback and interactions tab gives the details of
                        visitors / parents who have given their ratings / feedback and reply
                        option is provided to reply them (optional). (same can be exported)
                      </li>
                    </ul>
                  </div>

                 </div>
              </div>

              
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default partnerReview;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/review.jsx